import save from "save-file";
import generateCSV from "../../services/CSVController";
import { denominatorToFull } from "../../utils/rawPrice";
import { toLocalDateTime } from "../../yoello-lib/modules/utils/TimeConversion";
import { OnboardingSource } from "../menu/payments/types.d";

type IReportType = { value: number };

interface ITotalReports {
    [key: string]: any;
    orders_complete_total: IReportType;
    orders_declined: IReportType;
    orders_placed: IReportType;
    orders_total_excl_tips: IReportType;
    orders_total_tips: IReportType;
    orders_voided: IReportType;
    orders_vat_total: IReportType;
    venue_name:string;
    serial_id:number;
    bank_transfer_payout_amount:number;
}

export function generateTotalReport(totalReport: ITotalReports, startDate: string, endDate: string, removeYoelloPayout: boolean,onboardingSource:OnboardingSource,venueName:string,showBankTransferAmount:boolean) {
    console.log('totalReport', totalReport)
    const reportData = generatePrice(totalReport);
    const arrayOfKeys = ["startDate", "endDate", "orders_placed", "orders_refunded", "orders_total_excl_tips", "orders_total_tips", "orders_complete_total", "orders_vat_total", "yoello_payout_amount"];
    const arrayOfHeaders = ["Report From", "Report To", "Total Revenue", "Total Refund Value", "Total (excl Tips)", "Tips", "Total (incl tips)", "Tax on Total (incl Tips)", "Yoello Payout Amount"];
    if(onboardingSource !== OnboardingSource.YOELLO){
        arrayOfHeaders.pop();
        arrayOfHeaders.push("Payout Amount");
    }
    if(onboardingSource === OnboardingSource.RMS){
        arrayOfKeys.pop();
        arrayOfHeaders.pop();
    }
    else if(removeYoelloPayout){
        arrayOfKeys.splice(arrayOfKeys.length - 1, 1, "total_yoello_fee");
        arrayOfHeaders.splice(arrayOfHeaders.length - 1, 1, "Total Yoello Fee");
    }else{
        arrayOfKeys.push("total_yoello_fee");
        if(onboardingSource !== OnboardingSource.YOELLO){
            arrayOfHeaders.push("Total Processing Fee");
        }else{
            arrayOfHeaders.push("Total Yoello Fee");
        }
        
    }
    if(showBankTransferAmount){
        arrayOfKeys.push("bank_transfer_payout_amount");
        arrayOfHeaders.push("Bank Transfer Payout Amount");
    }
    
    arrayOfKeys.push("venue_name","serial_id")
    arrayOfHeaders.push("Venue Name", "Venue ID")
    const csvString = generateCSV([{ startDate: toLocalDateTime(startDate, "DD/MM/YYYY HH:mm"), endDate: toLocalDateTime(endDate, "DD/MM/YYYY HH:mm"), ...reportData }], arrayOfKeys, arrayOfHeaders);
    save(csvString, `${venueName}-total-report-from${toLocalDateTime(startDate)}to${toLocalDateTime(endDate)}.csv`);
    return;
}


function generatePrice(totalReport: ITotalReports) {
    const newObject: any = {};
    for (const key in totalReport) {
        if(typeof(totalReport[key]) !== "object" ){
            newObject[key] = totalReport[key]
        }else{
            const value = totalReport[key].value
            newObject[key] = denominatorToFull(value)
        }
    }
    return newObject;
}